import React from "react";
import styles from "./partnersList.module.scss";
import { RichText } from "prismic-reactjs";
import "lazysizes";
import Imgix, { buildURL } from "react-imgix";

const PartnersList = ({ partners }) => (
  <div className={styles.partnersList}>
    {
      partners.map((partnerData, index) => {
        if (!partnerData) {
          return null;
        }

        const {
          partnerName: {
            0: { text: name },
          },
          partnerDescription,
          partnerLink,
          partnerPhoto,
        } = partnerData;

        return (
          <div className={styles.partnersList__item} key={name}>
            <div className={styles.partnersList__logo}>
              <a
                href={partnerLink && partnerLink.url}
                rel="noopener noreferrer"
                target="_blank"
              >
                <Imgix
                  className='lazyload'
                  src={partnerPhoto.url}
                  alt={partnerPhoto.alt ? partnerPhoto.alt : name}
                  width={250}
                  imgixParams={{ auto: 'compress,format' }}
                  attributeConfig={{
                    src: 'data-src',
                    srcSet: 'data-srcset',
                    sizes: 'data-sizes',
                  }}
                  htmlAttributes={{
                    src: buildURL(partnerPhoto.url, {
                      auto: 'compress,format',
                      blur: 100,
                      w: 250,
                    }),
                  }}
                />
              </a>
            </div>
            <div className={styles.partnersList__description}>
              {partnerDescription && <RichText render={partnerDescription} />}
            </div>
          </div>
        );
      })
    }
  </div>
);

export default PartnersList;
